// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_46-0";
export var eligibilityCardNotEligible = "_46-1";